export const types = {
  READY: 'RECEIPTS.READY',
  FETCHING_RECEIPTS: 'RECEIPTS.FETCHING_RECEIPTS',
  FETCHED_RECEIPTS: 'RECEIPTS.FETCHED_RECEIPTS',
  FETCH_RECEIPTS_FAILED: 'RECEIPTS.FETCH_RECEIPTS_FAILED',
  SET_CURRENT_RECEIPT: 'RECEIPTS.SET_CURRENT_RECEIPT'
};

export const ready = () => ({
  type: types.READY
});

export const fetchingReceipts = () => ({
  type: types.FETCHING_RECEIPTS
});

export const fetchedReceipts = data => ({
  type: types.FETCHED_RECEIPTS,
  data: data
});

export const fetchReceiptsFailed = () => ({
  type: types.FETCH_RECEIPTS_FAILED
});

export const setCurrentReceipt = receipt => ({
  type: types.SET_CURRENT_RECEIPT,
  receipt
});



// WEBPACK FOOTER //
// ./src/store/actions/receipts.js